"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasCheckMaxHeightModifierData = exports.checkMaxHeightModifier = void 0;
var _core = require("@popperjs/core");
const hasCheckMaxHeightModifierData = obj => {
  return obj !== null && typeof obj === "object" && Object.hasOwnProperty.call(obj, "height");
};
exports.hasCheckMaxHeightModifierData = hasCheckMaxHeightModifierData;
const checkMaxHeightModifier = {
  name: "checkMaxHeight",
  enabled: true,
  phase: "main",
  requiresIfExists: ["offset", "preventOverflow", "flip"],
  fn(_ref) {
    let {
      state,
      name,
      options
    } = _ref;
    const overflow = (0, _core.detectOverflow)(state, options);
    const {
      y
    } = state.modifiersData.preventOverflow || {
      x: 0,
      y: 0
    };
    const {
      height
    } = state.rects.popper;
    const [basePlacement] = state.placement.split("-");
    const heightProp = basePlacement === "top" ? "top" : "bottom";
    state.modifiersData[name] = {
      height: height - overflow[heightProp] - y
    };
  }
};
exports.checkMaxHeightModifier = checkMaxHeightModifier;
//# sourceMappingURL=checkMaxHeightModifier.js.map